import { Api } from '@/5_shared/api'

const fetchBalances = () => {
  return Api.post({
    cmd: 'balances',
  })
}

export const api = { fetchBalances }
